/*
 * ---------------------------------------------------------------------
 * import Action types
 * ---------------------------------------------------------------------
 */
import {
    SET_AGENDA,
} from "../actions/agenda/types";

/*
 * ---------------------------------------------------------------------
 * initial event state
 * ---------------------------------------------------------------------
 */
// Till now the event is null maybe in future we change this behaviour
const initialState = {
    // event core features mandatory
    list: null,
};


/*
 * ---------------------------------------------------------------------
 * stream reducer
 * ---------------------------------------------------------------------
 */
const stream = (state = initialState, action) => {
    switch (action.type) {
        case SET_AGENDA:
            return Object.assign({}, state, {
                list: action.payload,
            });

        default:
            return state;
    }
};

export default stream;
